import PropTypes from "prop-types";

import ProgressBar from "../../ProgressBar";
import SummaryItemGraphic from "../SummaryItemGraphic";
import { rootCss } from "./SummaryItemCount.style";

const propTypes = {
  correctAnswerCount: PropTypes.number,
  isPowerWordQuiz: PropTypes.bool,
  count: PropTypes.number,
  points: PropTypes.number,
};

const SummaryItemCount = ({
  correctAnswerCount,
  isPowerWordQuiz = false,
  count = 4,
  points = 0,
}) => {
  return (
    <div css={rootCss}>
      <ProgressBar current={count} count={count} />
      <SummaryItemGraphic
        correctAnswerCount={correctAnswerCount}
        count={isPowerWordQuiz ? points : count}
        isPowerWordQuiz={isPowerWordQuiz}
        points={points}
      />
    </div>
  );
};

SummaryItemCount.propTypes = propTypes;

export default SummaryItemCount;
